<template>
	<TwoPartsTreeBlock v-on="$listeners" :isChosen="isChosen">
		<template #first-part>
			<FlowTreeActionBlock
				disabled
				v-on="$listeners"
				:actionData="{}"
				:appData="subFlowMockService"
				:blockData="{ service: 'some-value', node_title: 'Subflow triggered' }"
			/>
		</template>
		<template #second-part> {{ blockData.node_title }} </template>
	</TwoPartsTreeBlock>
</template>

<script>
import { ServiceSlugs } from '@ply-io/ply-front-shared-utilities';

import FlowTreeActionBlock from './FlowTreeActionBlock.vue';
import TwoPartsTreeBlock from './TwoPartsTreeBlock.vue';
import { flatPreviousSteps, editNode } from '@/store/modules/selectedNode/getters';
import { mapGettersShorthand } from '@/store/utils/mappers';

export default {
	name: 'SubflowRootTreeBlock',
	components: { TwoPartsTreeBlock, FlowTreeActionBlock },
	props: { blockData: { Object } },
	computed: {
		...mapGettersShorthand({ flatPreviousSteps, editNode }),
		isChosen() {
			return this.editNode?.id === this.blockData.id;
		},
		subFlowMockService() {
			return {
				service_slug: ServiceSlugs.SubFlow,
			};
		},
	},
};
</script>
<style lang="scss" scoped>
.notification {
	transform: scale(0.6);
}
</style>
